import $ from "jquery";
import slick from "slick-carousel";

let $multipleItemCarousel = $(".multiple-item-carousel");

const multipleItemCarousel = {
	init: function() {
		multipleItemCarousel.setup();
	},

	setup: function() {
		if ($multipleItemCarousel.children().length > 1) {
			$multipleItemCarousel.each(function() {
				$multipleItemCarousel = $(this);
				$multipleItemCarousel.slick({
					slidesToShow: 2,
					slidesToScroll: 1,
					arrows: false,
					dots: true,
					prevArrow:
						'<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
					nextArrow:
						'<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
					adaptiveHeight: true,
					mobileFirst: true,
					lazyLoad: "ondemand",
					infinite: false,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 3,
								slidesToScroll: 1,
							},
						},
						{
							breakpoint: 992,
							settings: {
								slidesToShow: 4,
								slidesToScroll: 1,
							},
						},
					],
				});
			});
		}
	},
};

export default multipleItemCarousel;
